/**
 * This component has the unique purpose to improve code semantics and help us
 * in future if there is a need to customize `Heading` margin standards.
 */

const Heading = ({ children }) => children;

export default Heading;
